export default __webpack_public_path__ + "static/media/sbi.e7a15e18.png";